import { type OutgoingPaymentMapper } from '@tectonics/prs/outgoing-payment/mapper/types';

const DEFAULT_INSTALMENTS = '1' as const;
const PAYMENT_METHODS_WITH_INSTALMENTS: readonly string[] = ['creditcard', 'google', 'oneclick'];

export const instalmentsPlanOutgoingPaymentMapper: OutgoingPaymentMapper = (userInputValues) => {
  const { selectedInstalment, selectedPaymentMethod } = userInputValues;
  const paymentMethod = typeof selectedPaymentMethod === 'string' ? selectedPaymentMethod : '';
  const instalment =
    typeof selectedInstalment === 'string' || typeof selectedInstalment === 'number'
      ? String(selectedInstalment)
      : DEFAULT_INSTALMENTS;

  const instalments = PAYMENT_METHODS_WITH_INSTALMENTS.includes(paymentMethod)
    ? instalment
    : DEFAULT_INSTALMENTS;

  return { instalments };
};
